import type { AssetAction, AssetChange } from '@gotti/core';
import { makeServerAssetsFacade } from './assetsFacade.js';
import type { ServerAssetManager } from './ServerAssetManager.js';

/**
 * Attach `$assets` to a system + wire its asset hooks to the shared per-process
 * manager. The manager fires listeners AFTER its cache is coherent (see
 * BaseAssetManager.applyRemoteChange), so a hook that re-reads sees fresh data.
 */
export function attachServerAssets(system: any, mgr: ServerAssetManager): () => void {
  // Defined once per instance (non-writable, non-configurable): a rolled-back
  // hot reload re-attaches the previous instance, which already has it. (A
  // fresh instance may carry a plain, configurable `$assets` class field.)
  if (Object.getOwnPropertyDescriptor(system, '$assets')?.configurable !== false) {
    Object.defineProperty(system, '$assets', { value: makeServerAssetsFacade(mgr), writable: false });
  }
  return mgr.onChange((action: AssetAction, change: AssetChange) => {
    if (action === 'updated') system.onAssetUpdated?.(change);
    else system.onAssetRemoved?.(change);
  });
}
